"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const _1 = require(".");
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(_1.SubNotice, { noticeType: t('안내'), noticeLine: t('구매자는 [제목, 작품명, 태그]로 검색해요!') }));
}
exports.default = default_1;
